module.exports = __webpack_public_path__ + "img/icon_map.6fb91de2.svg";